import { z } from 'zod';

export const SuperAdminCatalogPageFilterFormSchema = z.object({
    tenantId: z.string().nullable(),
    ownerId: z.string().nullable(),
    searchText: z.string().nullable(),
});

export type SuperAdminCatalogPageFilterFormData = z.infer<typeof SuperAdminCatalogPageFilterFormSchema>;
